import changeHistoryService from '@/api/change-history-service';

export const getDefaultChangeHistoryFilterParams = () => ({});

const state = {
  changeHistory: null,
  changeHistoryPagination: {},
  changeHistoryFilterParams: getDefaultChangeHistoryFilterParams(),
};

const getters = {};

const mutations = {
  SET_CHANGE_HISTORY(state, { data, current_page, per_page, total }) {
    state.changeHistory = data;
    state.changeHistoryPagination = {
      current_page,
      per_page,
      total,
    };
  },

  SET_CHANGE_HISTORY_FILTER_PARAMS(state, params) {
    state.changeHistoryFilterParams = params;
  },
};

const actions = {
  fetchChangeHistory({ commit }, params) {
    commit('SET_CHANGE_HISTORY_FILTER_PARAMS', params);
    return changeHistoryService.getPage(params).then((res) => {
      commit('SET_CHANGE_HISTORY', res.data);
      return res.data;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
